var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 22.5C17.7165 22.5 18.5 21.7165 18.5 20.75C18.5 19.7835 17.7165 19 16.75 19C15.7835 19 15 19.7835 15 20.75C15 21.7165 15.7835 22.5 16.75 22.5Z",
    fill: "url(#paint0_linear_1721_53247)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 22.5C9.7165 22.5 10.5 21.7165 10.5 20.75C10.5 19.7835 9.7165 19 8.75 19C7.7835 19 7 19.7835 7 20.75C7 21.7165 7.7835 22.5 8.75 22.5Z",
    fill: "url(#paint1_linear_1721_53247)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34 3.94L5.14 6.39C5.1 6.86 5.47 7.25 5.94 7.25H21.25C21.67 7.25 22.02 6.93 22.05 6.51C22.18 4.74 20.83 3.3 19.06 3.3H6.77C6.67 2.86 6.47 2.44 6.16 2.09C5.66 1.56 4.96 1.25 4.24 1.25H2.5C2.09 1.25 1.75 1.59 1.75 2C1.75 2.41 2.09 2.75 2.5 2.75H4.24C4.55 2.75 4.84 2.88 5.05 3.1C5.26 3.33 5.36 3.63 5.34 3.94Z",
    fill: "url(#paint2_linear_1721_53247)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0101 8.75H5.67005C5.25005 8.75 4.91005 9.07 4.87005 9.48L4.51005 13.83C4.37005 15.54 5.71005 17 7.42005 17H18.5401C20.0401 17 21.3601 15.77 21.4701 14.27L21.8001 9.6C21.8401 9.14 21.4801 8.75 21.0101 8.75Z",
    fill: "url(#paint3_linear_1721_53247)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1721_53247",
    x1: 16.75,
    y1: 19,
    x2: 16.75,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1721_53247",
    x1: 8.75,
    y1: 19,
    x2: 8.75,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1721_53247",
    x1: 11.9043,
    y1: 1.25,
    x2: 11.9043,
    y2: 7.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1721_53247",
    x1: 13.1515,
    y1: 8.75,
    x2: 13.1515,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingActive);
export default __webpack_public_path__ + "static/media/shopping-active.c1f073b72936a3752346c149dd4bb2a3.svg";
export { ForwardRef as ReactComponent };